import { type LocaleConfig, resolveLocaleConfig } from '@owner/localization'
import { getActivePinia } from 'pinia'
import { computed, type ComputedRef } from 'vue'

import { useCoreStore } from '../useCoreStore'

/**
 * The active brand's country/currency/distance conventions, resolved at call
 * time.
 *
 * Reads the core store directly rather than going through `useActiveBrand()`, so
 * that formatters invoked outside a component — table column configs, for
 * instance — can still resolve one. Surfaces that render without the app's
 * store at all, such as Storybook, get the default rather than an exception.
 *
 * A brand created before `country` existed resolves to the US/USD default.
 */
export const getActiveLocaleConfig = (): LocaleConfig => {
  const country = getActivePinia()
    ? useCoreStore().activeBrand?.country
    : undefined

  return resolveLocaleConfig(country)
}

/** Reactive {@link getActiveLocaleConfig}, for use inside components. */
export const useLocaleConfig = (): ComputedRef<LocaleConfig> =>
  computed(() => getActiveLocaleConfig())
